
import axios from 'axios';
import router from '../router';

axios.interceptors.request.use(request => {
  request.timeout = 10000;
  request.withCredentials = true;
  return request;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  if (response.status >= 500 && response.status <= 600) {
    router.push('/exception');
  }
  return response;
}, (error) => {
  return Promise.reject({ message: '网络异常，请稍后再试' });
});

export default {
  get: function(target, params = {}) {
    return axios({
      url: target,
      method: 'get',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      params
    }).then(res => {
      return Promise.resolve(res.data);
    }).catch((error) => {
      error.returncode = -2;
      return Promise.reject(error);
    });
  },
  post: function(target, params = {}) {
    return axios({
      url: target,
      method: 'post',
      data: JSON.stringify(params),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(res => {
      return Promise.resolve(res.data);
    }).catch((error) => {
      error.returncode = -2;
      return Promise.reject(error);
    });
  }
};
